import { apiFetch } from './apiFetch';

/** Mark the first-time onboarding wizard complete (also used for "skip"). */
export async function completeOnboarding(): Promise<{ completed: boolean }> {
  return apiFetch('/onboarding/complete', { method: 'POST' });
}
